<template>
  <div class="p-top-information">
    <div class="p-top-information__inner">

      <!-- 未読のみボタン -->
      <div class="p-top-information__header">
        <p class="heading">お知らせ</p>
        <div class="unreadCheck">
          <p class="unreadCheck__label">未読のみ</p>
          <div class="c-parts-toggle -home js-toggle" @click="toggleOnlyUnreadSwitch()">
            <span class="label"></span>
            <span class="toggle"></span>
          </div>
        </div>
      </div>
      <!-- 未読のみボタン 終わり -->

      <!-- お知らせ一覧 -->
      <div class="p-top-information__body">
        <div class="scrollArea">
          <ul>
          <template v-if="notificationListStore.notificationData !== null && notificationListStore.notificationData.length > 0">
            <li class="p-top-information__list" v-for="notification in notificationListStore.notificationData" :key="notification.uuid">
            <p class="p-top-information__list-important" v-if="notification.is_important">重要</p>
            <p class="p-top-information__list-header" v-bind:class="{ '-unread': notification.is_unread }">
              <a :href="createNotificationUrl(notification.uuid)">{{ notification.title }}</a>
            </p>
            <p class="p-top-information__list-exp">
              <plain-text-view :markdownText="notification.body"></plain-text-view>
            </p>
            <time :datetime="displayDateTime(notification.start_datetime, 'datetime')" class="p-top-information__list-pubtime">
              {{ displayDateTime(notification.start_datetime, "date") }}
              <span class="time">{{ displayDateTime(notification.start_datetime, "time") }}</span>
            </time>
            </li>
          </template>
          <template v-else>
            <li class="p-top-information__list">
            <span v-if="notificationListStore.onlyUnreadFlag">未読のお知らせはありません</span>
            <span v-else>お知らせはありません</span>
            </li>
          </template>
          </ul>
        </div>
      </div>
      <!-- お知らせ一覧 終わり -->

    </div>
  </div>
</template>


<script setup lang="ts">
  import {onMounted} from "vue";
  import { format, parseISO } from "date-fns";
  import { useNotificationListStore } from "@/store/teacher/notification_list_store";

  const notificationListStore = useNotificationListStore()

  onMounted(() => {
    // お知らせ一覧を取得
    notificationListStore.fetchNotificationList(false);
  })

  function createNotificationUrl(uuid: string) {
    return notificationListStore.notificationBaseUrl + uuid + "/"
  }

  function displayDateTime(dateString: string, dateType: string) {
    // ISO-8601 形式のdateStringを変換する
    let fmtString = "";

    if (dateType == "date") {  // dateType == "date"の場合、"2021年12月03日" の形に変換する
      fmtString = "yyyy年M月dd日";
    } else if (dateType == "time") {  // dateType == "time"の場合、"12:31" の形に変換する（秒は省略）
      fmtString = "HH:mm";
    } else if (dateType == "datetime") {  // dateType == "datetime"の場合、"2021年12月03日T12:31" の形に変換する（秒は省略）
      fmtString = "yyyy年M月dd日'T'HH:mm";
    } else {
      return "";
    }

    try {
      let date = parseISO(dateString);
      return format(date, fmtString);
    } catch {
      return "";
    }
  }

  function toggleOnlyUnreadSwitch() {
    notificationListStore.saveOnlyUnreadFlag(!notificationListStore.onlyUnreadFlag);
    notificationListStore.fetchNotificationList(notificationListStore.onlyUnreadFlag);
  }
</script>
